import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AsyncComponentLoading({
  bundleName,
  error,
  pastDelay,
  retry,
  useSpinner
}) {
  const [retriesLeft, setRetriesLeft] = useState(2);
  const handleRetry = () => {
    if (retriesLeft > 0 && retry) {
      retry();
      setRetriesLeft(retriesLeft - 1);
      return;
    }
    Raven.captureMessage(`Bundle: ${bundleName} All retries exhausted`);
    setTimeout(window.location.reload, 250);
  };
  if (error) {
    return /*#__PURE__*/_jsxs("div", {
      className: "text-center m-top-5",
      children: [/*#__PURE__*/_jsx("h1", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-publishing.asyncComponent.errorTitle"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-publishing.asyncComponent.error"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: handleRetry,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-publishing.asyncComponent.reload"
        })
      })]
    });
  }
  if (pastDelay) {
    if (useSpinner) {
      return /*#__PURE__*/_jsx(UIFlex, {
        align: "center",
        direction: "column",
        children: /*#__PURE__*/_jsx(UILoadingSpinner, {
          className: "m-top-5",
          grow: true
        })
      });
    }
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      className: "m-top-5",
      grow: true
    });
  }
  return null;
}